import { TRootState } from '#/redux/store';
import { useSelector } from 'react-redux';

const profileSelector = (state: TRootState) => state.profile;

const useProfile = () => {
  const profile = useSelector(profileSelector);

  return profile;
};

export default useProfile;
